import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import moment from "moment";
import React from "react";
import { LUEvent } from "../../data/events.api";
import placeholderImg from "../../assets/event-placeholder.jpg";
import { useNavigate } from "react-router-dom";

type Props = {
  event: LUEvent;
};

const EventCard = ({ event }: Props) => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.700");
  const secondaryBg = useColorModeValue("white", "gray.900");
  const hoverColour = useColorModeValue("gray.100", "gray.600");

  return (
    <Flex
      border="1px solid rgba(0, 0, 0, 0.1)"
      rounded="md"
      overflow="hidden"
      role="group"
      bg={bg}
      cursor="pointer"
      transition=".1s all"
      _hover={{ bg: hoverColour }}
      onClick={() => navigate(`/events/${event.eventId}`)}
    >
      <Flex p={3} flex={1} gap={3}>
        <Flex
          direction="column"
          justify="center"
          alignItems="center"
          p={2}
          px={3}
          rounded="md"
          bg={secondaryBg}
          border="1px solid"
          borderColor="blackAlpha.300"
        >
          <Text fontSize="xs" opacity={0.6}>
            {moment(event.startDate).format("MMM").toUpperCase()}
          </Text>
          <Text fontSize="3xl" my={-2}>
            {moment(event.startDate).format("D")}
          </Text>
          <Text fontSize="xs" opacity={0.6}>
            {moment(event.startDate).format("ddd").toUpperCase()}
          </Text>
        </Flex>
        <Flex direction="column" flex={1}>
          <Heading size="sm" mb={1}>
            {event.title}
          </Heading>
          {event.shortDescription ? (
            <Text fontSize="xs">
              {event.shortDescription.slice(0, 50)}
              {event.shortDescription.length > 50 ? "..." : ""}
            </Text>
          ) : null}
        </Flex>
      </Flex>
      <Image
        src={event.imageLink ?? placeholderImg}
        alt={event.imageAltText}
        objectFit="cover"
        w={24}
      />
    </Flex>
  );
};

export default EventCard;
